module.exports = __webpack_public_path__ + "static/assets/f9f80a46c79989ec217b139a9faa11c7.png";